import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IOnlineTrainingCredits } from 'types/onlineTrainingCredits';

const name = 'onlineTrainingCredits';

type FetchParams = {
  userId: string;
  organizationId: string;
  afterSuccess?: () => void;
};

export const fetchOnlineTrainingCredits = createAsyncThunk(
  `${name}/fetch`,
  async ({ userId, organizationId, afterSuccess }: FetchParams, { dispatch }) => {
    try {
      const { data } = await axios.get<IOnlineTrainingCredits>(
        `/api/v1/products/addons/humanfocus/organizations/${organizationId}/users/${userId}/credits`
      );

      afterSuccess && afterSuccess();
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  credits: IOnlineTrainingCredits;
};

const initialState: State = {
  credits: {
    IsPending: false,
    Credits: 0,
    Breakdown: {}
  } as IOnlineTrainingCredits,
  isFetching: false,
  error: null
};

const onlineTrainingCredits = createSlice({
  name,
  initialState,
  reducers: {
    changeIsFetchingCredits(state) {
      state.isFetching = !state.isFetching;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOnlineTrainingCredits.pending, isFetching)
      .addCase(fetchOnlineTrainingCredits.fulfilled, (state, action) => {
        state.credits = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchOnlineTrainingCredits.rejected, error);
  }
});

export const {
  reducer: onlineTrainingCreditsReducer,
  actions: { changeIsFetchingCredits }
} = onlineTrainingCredits;
